module.exports = __webpack_public_path__ + "static/media/hands-heart.e4379216.svg";